<template>
	<div id="app">
        <div class="card border-primary" style="margin-bottom:20px;">
			<div class="card-header">
				<h5 style="margin-bottom:0px;">Sport Radar Odds Comparison Player Props API</h5>
			</div>
			<div class="card-body">
				<div class="form-row">
                    <div class="col">
						<div class="form-group" v-if="sports.length != 0">
                            <label>Sports</label>
                            <select @change="selectSport" class="form-control">
                                <option value="">-- Select --</option>
                                <option v-for="sport in sports" :value="sport.id" :key="sport.id">
                                    {{ sport.name }}
                                </option>
                            </select>
                        </div>
					</div>
                    <div class="col">
						<div class="form-group" v-if="competitions.length != 0">
                            <label>Competitions</label>
                            <select @change="selectCompetition" class="form-control">
                                <option value="">-- Select --</option>
                                <option v-for="competition in competitions" :value="competition.id" :key="competition.id">
                                    {{ competition.name }} {{ getCompetitionCountry(competition)}}
                                </option>
                            </select>
                        </div>
					</div>
                    <div class="col">
            <div class="form-group" v-if="apiLoading">Loading... Please wait!</div>
						<div class="form-group" v-if="competitionPlayerProps.length != 0">
                <label>Sport events</label>
                <select @change="selectSportEvent" class="form-control">
                    <option value="">-- Select --</option>
                    <option v-for="event in competitionPlayerProps" :value="event.sport_event.id" :key="event.sport_event.id">
                         {{ event.sport_event.start_time }} - {{ getSportEventName(event.sport_event) }}
                    </option>
                </select>
            </div>
					</div>
				</div>
				
				<div>
					<p>These are the SportRadar's endpoints used to build this page.</p>
					<table class="table" style="text-align:left;">
						<tr>
							<td>Sports</td>
							<td>
                                <a :href="getSportsEndpoint(true)" target="_blank">{{ getSportsEndpoint(true) }}</a>
                            </td>
						</tr>
                        <tr v-if="getCompetitionsEndpoint()">
							<td>Competitions</td>
							<td>
                                <a :href="getCompetitionsEndpoint(true)" target="_blank">{{ getCompetitionsEndpoint(true) }}</a>
                            </td>
						</tr>
                        <tr v-if="getCompetitionPlayerPropsEndpoint()">
							<td>Competition Player Props</td>
							<td>
                                <a :href="getCompetitionPlayerPropsEndpoint(true)" target="_blank">{{ getCompetitionPlayerPropsEndpoint(true) }}</a>
                            </td>
						</tr>
					</table>
				</div>

                <div>
					<p>These are exmaples of SportRadar's Odds Comparison Player Props API</p>
					<table class="table" style="text-align:left;">
						<tr>
							<td>Books</td>
							<td>
                                <a :href="getBooksEndpoint(true)" target="_blank">{{ getBooksEndpoint(true) }}</a>
                            </td>
						</tr>
                        <tr>
							<td>Competition Mappings</td>
							<td>
                                <a :href="getCompetitionMappingsEndpoint(true)" target="_blank">{{ getCompetitionMappingsEndpoint(true) }}</a>
                            </td>
						</tr>
                        <tr>
							<td>Competition Player Props</td>
							<td>
                                <a :href="getCompetitionPlayerProbsExampleEndpoint(true)" target="_blank">{{ getCompetitionPlayerProbsExampleEndpoint(true) }}</a>
                            </td>
						</tr>
                        <tr>
							<td>Competitor Mappings</td>
							<td>
                                <a :href="getCompetitorMappingsEndpoint(true)" target="_blank">{{ getCompetitorMappingsEndpoint(true) }}</a>
                            </td>
						</tr>
                        <tr>
							<td>Daily Sport Player Props</td>
							<td>
                                <a :href="getDailySportPlayerPropsEndpoint(true)" target="_blank">{{ getDailySportPlayerPropsEndpoint(true) }}</a>
                            </td>
						</tr>
                        <tr>
							<td>Player Mappings</td>
							<td>
                                <a :href="getPlayerMappingsEndpoint(true)" target="_blank">{{ getPlayerMappingsEndpoint(true) }}</a>
                            </td>
						</tr>
                        <tr>
							<td>Player Props Change Log</td>
							<td>
                                <a :href="getPlayerPropsChangeLogEndpoint(true)" target="_blank">{{ getPlayerPropsChangeLogEndpoint(true) }}</a>
                            </td>
						</tr>
                        <tr>
							<td>Sport Categories</td>
							<td>
                                <a :href="getSportCategoriesEndpoint(true)" target="_blank">{{ getSportCategoriesEndpoint(true) }}</a>
                            </td>
						</tr>
                        <tr>
							<td>Sport Competitions</td>
							<td>
                                <a :href="getSportCompetitionsExampleEndpoint(true)" target="_blank">{{ getSportCompetitionsExampleEndpoint(true) }}</a>
                            </td>
						</tr>
                        <tr>
							<td>Sport Events Mappings</td>
							<td>
                                <a :href="getSportEventMappingsEndpoint(true)" target="_blank">{{ getSportEventMappingsEndpoint(true) }}</a>
                            </td>
						</tr>
                        <tr>
							<td>Sport Event Player Props</td>
							<td>
                                <a :href="getSportEventPlayerPropsEndpoint(true)" target="_blank">{{ getSportEventPlayerPropsEndpoint(true) }}</a>
                            </td>
						</tr>
                        <tr>
							<td>Sport Stages</td>
							<td>
                                <a :href="getSportStagesEndpoint(true)" target="_blank">{{ getSportStagesEndpoint(true) }}</a>
                            </td>
						</tr>
                        <tr>
							<td>Sports</td>
							<td>
                                <a :href="getSportsEndpoint(true)" target="_blank">{{ getSportsEndpoint(true) }}</a>
                            </td>
						</tr>
                        <tr>
							<td>Stage Mappings</td>
							<td>
                                <a :href="getStageMappingsEndpoint(true)" target="_blank">{{ getStageMappingsEndpoint(true) }}</a>
                            </td>
						</tr>
					</table>
				</div>
				
			</div>
		</div>

        <div v-if="sportEventId">
            <div id="accordion">
                <div class="card">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#game" aria-expanded="true" aria-controls="collapseOne">
							Sport Event Info
							</button>
						</h5>
					</div>

					<div id="game" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">	
							<table class="table">
                                <tr>
                                    <th>scheduled</th>
                                    <th>home</th>
                                    <th>away</th>
                                </tr>
                                <tr v-if="sportEvent">
                                    <td>
                                        id: {{ sportEvent.sport_event.id }}<br>
                                        scheduled: {{ sportEvent.sport_event.start_time }}<br>
                                        is date confirmed: {{ sportEvent.sport_event.start_time_confirmed }}
                                    </td>
                                    <td>
                                        id: {{ home.id }}<br>
                                        name: {{ home.name }}<br>
                                        country: {{ home.country }}<br>
                                        country_code: {{ home.country_code }}<br>
                                        abbreviation: {{ home.abbreviation }}<br>
                                        qualifier: {{ home.qualifier }}<br>
                                        rotation_number: {{ home.rotation_number }}<br>
                                    </td>
                                    <td>
                                        id: {{ away.id }}<br>
                                        name: {{ away.name }}<br>
                                        country: {{ away.country }}<br>
                                        country_code: {{ away.country_code }}<br>
                                        abbreviation: {{ away.abbreviation }}<br>
                                        qualifier: {{ away.qualifier }}<br>
                                        rotation_number: {{ away.rotation_number }}<br>
                                    </td>
                                </tr>
                            </table>
						</div>                            
					</div>               
				</div>

                <div class="card" v-if="sportEvent.players_props">
					<div class="card-header" id="headingTwo">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#playersprops" aria-expanded="true" aria-controls="collapseTwo">
							Sport Event Players Props
							</button>
						</h5>
					</div>

					<div id="playersprops" class="collapse show" aria-labelledby="headingTwo">
						<div class="card-body">
                            <PlayersProps 
                                :playersProps="sportEvent.players_props">
                            </PlayersProps>
						</div>                            
					</div>               
				</div>

                <div class="card" v-if="sportEvent.players_markets">
					<div class="card-header" id="headingThree">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#markets" aria-expanded="true" aria-controls="headingThree">
							Sport Event Players Markets
							</button>
						</h5>
					</div>

					<div id="markets" class="collapse show" aria-labelledby="headingThree">
						<div class="card-body">
                            <PlayersMarkets 
                                :playersMarkets="sportEvent.players_markets">
                            </PlayersMarkets>
						</div>                            
					</div>               
				</div>
            </div>
        </div>
	</div>
</template>

<script>
import PlayersProps from './components/PlayersProps.vue'
import PlayersMarkets from './components/PlayersMarkets.vue'
import axios from 'axios'

const API_KEY = 'cp7tt3dgjcs39ubz4pv8p2zh';

export default {
	name: 'app',
  	components: {
		PlayersProps,
        PlayersMarkets
	},
	data: function() {
		return {
            apiKey: API_KEY,
            sports: [],
			competitions: [],
            competitionPlayerProps: [],
      apiLoading: false,
            playerPropsChangeLog: [],
            sportId: '',
			competitionId: '',
            dateToday: '',
            sportEventId: '',
            sportEvent: '',
            home: '',
            away: ''
		}
	},  
	created: function() {

		this.loadSports();
	
	},
	methods: {
        getCompetitionCountry: function(competition) {
            let country = null;

            if(competition && competition.category && competition.category.name){
                country = competition.category.name;
            }

            return country;
        },

        getSportEventName: function(event) {
            return event.competitors[0].name + ' vs ' + event.competitors[1].name;
        },

        getSportsEndpoint: function(showBetradarUrl = false) {
            let url = `https://api.sportradar.us/oddscomparison-player-props/production/v2/en/sports.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getCompetitionsEndpoint: function(showBetradarUrl = false) {
            if(this.sportId == '') {
                return '';
            }

            let url = `https://api.sportradar.us/oddscomparison-player-props/production/v2/en/sports/${this.sportId}/competitions.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getCompetitionPlayerPropsEndpoint: function(showBetradarUrl = false) {
            if(this.competitionId == '') {
                return '';
            }

            let url = `https://api.sportradar.us/oddscomparison-player-props/production/v2/en/competitions/${this.competitionId}/players_props.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        loadSports: function() {

            // get full list of sports
            axios.get(this.getSportsEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('sports', response.data.sports);

                this.sports = response.data.sports;
                    
            
            }, (error) => {
                console.log(error)
            });
        },

        loadCompetitions: function() {

            // get full list of competitions
            axios.get(this.getCompetitionsEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('competitions', response.data.competitions);

                this.competitions = response.data.competitions;
                    
            
            }, (error) => {
                console.log(error)
            });
        },

        loadCompetitionPlayerProps: async function() {
            this.competitionPlayerProps = [];
            this.apiLoading = true;

            let url = this.getCompetitionPlayerPropsEndpoint();

            // Accordingly to the documentation, the max limit is 5
            // @see https://developer.sportradar.com/docs/read/odds/Odds_Comparison_Player_Props#competition-player-props
            const limit = 5;
            // To avoid infinite loop;
            let maxCounter = 100;
            let start = 0;
            let competitionSportEventsPlayersProps = [];
            let pageResult = [];

            do {
                const paginatedUrl = `${url}&start=${start}&limit=${limit}`;
                // get full list of competitions
                await axios.get(paginatedUrl,
                    { crossdomain: true })
                    .then((response) => {

                        pageResult = response.data.competition_sport_events_players_props;
                        console.log('competition player props from the url '+paginatedUrl, pageResult);
                        competitionSportEventsPlayersProps = competitionSportEventsPlayersProps.concat(pageResult);

                    }, (error) => {
                      console.log(error)
                    })
                ;
                maxCounter--;
                start += limit;
            } while (pageResult.length === limit && maxCounter > 0);

            this.apiLoading = false;
            this.competitionPlayerProps = competitionSportEventsPlayersProps;
        },

        selectSport: function(event) {

			this.sportId = event.target.value;
            this.competitionPlayerProps = [];
            this.sportEventId = '';
            this.sportEvent = '';
			this.loadCompetitions();		
		},

		selectCompetition: function(event) {

			this.competitionId = event.target.value;
			this.loadCompetitionPlayerProps();			
		},

        selectSportEvent: function(event) {
	
            this.sportEventId = event.target.value;          
            this.sportEvent = this.competitionPlayerProps.find(function(game) {
                return game.sport_event.id == event.target.value;
            });

            this.home = this.sportEvent.sport_event.competitors.find(function(competitor) {
                return competitor.qualifier == 'home';
            });

            this.away = this.sportEvent.sport_event.competitors.find(function(competitor) {
                return competitor.qualifier == 'away';
            });
		},

        // ---- start: example endpoints only ---- //
        getBooksEndpoint: function(showBetradarUrl = false) {
            let url = `https://api.sportradar.us/oddscomparison-player-props/production/v2/en/books.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },
        getCompetitionMappingsEndpoint: function(showBetradarUrl = false) {
            let url = `https://api.sportradar.us/oddscomparison-player-props/production/v2/en/competitions/mappings.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },
        getCompetitionPlayerProbsExampleEndpoint: function(showBetradarUrl = false) {
            let url = `https://api.sportradar.us/oddscomparison-player-props/production/v2/en/competitions/sr:competition:234/players_props.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },
        getCompetitorMappingsEndpoint: function(showBetradarUrl = false) {
            let url = `https://api.sportradar.us/oddscomparison-player-props/production/v2/en/competitors/mappings.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },
        getDailySportPlayerPropsEndpoint: function(showBetradarUrl = false) {
            let url = `https://api.sportradar.us/oddscomparison-player-props/production/v2/en/sports/sr:sport:1/schedules/2022-02-01/players_props.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },
        getPlayerMappingsEndpoint: function(showBetradarUrl = false) {
            let url = `https://api.sportradar.us/oddscomparison-player-props/production/v2/en/players/mappings.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },
        getPlayerPropsChangeLogEndpoint: function(showBetradarUrl = false) {
            let url = `https://api.sportradar.us/oddscomparison-player-props/production/v2/en/players_props_changelog.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },
        getSportCategoriesEndpoint: function(showBetradarUrl = false) {
            let url = `https://api.sportradar.us/oddscomparison-player-props/production/v2/en/sports/sr:sport:2/categories.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },
        getSportCompetitionsExampleEndpoint: function(showBetradarUrl = false) {
            let url = `https://api.sportradar.us/oddscomparison-player-props/production/v2/en/sports/sr:sport:1/competitions.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },
        getSportEventMappingsEndpoint: function(showBetradarUrl = false) {
            let url = `https://api.sportradar.us/oddscomparison-player-props/production/v2/en/sport_events/mappings.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },
        getSportEventPlayerPropsEndpoint: function(showBetradarUrl = false) {
            let url = `https://api.sportradar.us/oddscomparison-player-props/production/v2/en/sport_events/sr:sport_event:31372395/players_props.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },
        getSportStagesEndpoint: function(showBetradarUrl = false) {
            let url = `https://api.sportradar.us/oddscomparison-player-props/production/v2/en/sports/sr:sport:1/stages.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },
        getStageMappingsEndpoint: function(showBetradarUrl = false) {
            let url = `https://api.sportradar.us/oddscomparison-player-props/production/v2/en/stages/mappings.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },
        // ---- end: example endpoints only ---- //
	}  
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
  font-size: 12px;
}

table {
	width: 100%;
}

</style>

